import * as React from 'react'
import { useEffect } from 'react';
import { apiConstants, deleteGeneric, get, getGeneric, post, postGeneric } from '../../common/constants'
import {
    Typography, Card, CardContent, Grid, Button, CardHeader, Tooltip, IconButton,
    Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions
} from '@mui/material';
import ProzoDataGrid from '../../common/ProzoDataGrid';
import { useState } from 'react';
import { FormProvider, RHFSearchableSelectField, RHFSelectField } from '../../common/hook-form';
import { LoadingButton } from '@mui/lab';
import { useForm } from 'react-hook-form';
import PageTitle from '../../components/PageTitle';
import Loader from '../../common/Loader';
import AddIcon from '@mui/icons-material/Add';
import { useGetAllCourierPartnersCachedQuery } from '../../redux/commonApiCalls';
import _ from 'lodash';
import SideDrawer from '../../components/SideDrawer';
import { decodeHtmlString } from '../../helpers/UtilityHelper';
import { formatDate } from '../../common/util';
import VisibilityIcon from '@mui/icons-material/Visibility';
import BorderColorIcon from '@mui/icons-material/BorderColor';
import AddEditQCClickpostMapping from './AddMapping';
import ViewHTMLPreview from './ViewPreview';
import { useSnackbar } from 'notistack';

export default function QcClickPost() {
    const [page, setPage] = useState(0);
    const [sizePerPage, setSizePerPage] = useState(10);
    const [isSubmitting, setIsSubmitting] = useState(false)
    const [isLoading, setIsLoading] = useState(false);
    const [open, setOpen] = useState(false);
    const [addOpen, setAddOpen] = useState(false);
    const [previewOpen, setPreviewOpen] = useState(false);
    const [isEditData, setIsEditData] = useState(null);
    const [reload, setReload] = useState(0);
    const { enqueueSnackbar } = useSnackbar();
    const [val, setVal] = useState({
        rowData: null,
        type: null
    });
    const andfilter = [{ "field": "is_deleted", "operator": "eq", "value": '0' }];
    const filter = {
        "andfilter": andfilter,
        "offset": 0,
        "limit": 1000,
        "skipCount": true,
        "includes": "id,name,cpAccountCode,prozoId,supportedShipmentType,isBlended,type,cp_id,qcReturnReasons"
    }
    const { data: courierList } = useGetAllCourierPartnersCachedQuery(filter);

    const [data, setData] = useState(null);
    const methods = useForm({
        defaultValues: {
            courier: '',
            isActive: ''
        }
    })
    const { handleSubmit, reset } = methods;

    const onSubmit = async (data) => {
        setIsSubmitting(true)
        getGeneric(`${apiConstants.GET_QC_CLICKPOST_MAPPING_BY_CP_ACCOUNT_CODE}?cpAccountCode=${data.courier}&isActive=${data.isActive}`).then((res) => {
            setData(res?.data)
        }).catch((err) => console.log(err)).finally(() => {
            setIsSubmitting(false)
        })
    }

    useEffect(() => {
        setIsLoading(true)
        get(apiConstants.GET_QC_CLICKPOST_MAPPING).then((res) => {
            setData(res?.data)
        }).catch((err) => console.log(err)).finally(() => {
            setIsLoading(false)
        })
    }, [reload])

    const statusOptions = [
        { label: 'Active', value: true },
        { label: 'InActive', value: false },
    ]

    const Columns = [
        {
            field: 'cpAccountCode',
            headerName: 'Account Code',
            flex: 0.7,
            align: 'left',
        },
        {
            field: 'lastModifiedDate', headerAlign: "left", hideSortIcons: true, headerName: 'Modified User & Date', flex: 1,
            renderCell: (params) => {
                const { row } = params;
                return (
                    <Grid container direction="column">
                        <Grid item>{row?.modifiedByUser}</Grid>
                        <Grid item style={{ fontSize: '0.8rem', color: '#666' }}>{formatDate(row?.lastModifiedDate)}</Grid>
                    </Grid>
                );
            }
        },
        {
            field: 'isEmailSent',
            headerName: 'Email Delivery Mode',
            flex: 0.8,
            align: 'left',
            renderCell: (col) => {
                const { isEmailSent, isEmailSentManually } = col.row;

                return (
                    <Grid container rowSpacing={1}>
                        {isEmailSent && (
                            <Grid item xs={12}>
                                Automatic
                            </Grid>
                        )}
                        {isEmailSentManually && (
                            <Grid item xs={12}>
                                Manual
                            </Grid>
                        )}
                    </Grid>
                );
            }
        },
        {
            field: 'action',
            headerName: 'Action',
            flex: 0.6,
            align: 'left',
            renderCell: (col) => {
                return (
                    <>
                        <Tooltip title="View Mapping">
                            <IconButton
                                onClick={() => handleViewDetails(col.row)}
                                color="primary" size="small">
                                <VisibilityIcon fontSize="small" />
                            </IconButton>
                        </Tooltip>
                        <Tooltip title="Edit" sx={{ ml: 2 }}>
                            <IconButton
                                onClick={() => handleEdit(col.row)}
                                color="error" size="small">
                                <BorderColorIcon fontSize="small" />
                            </IconButton>
                        </Tooltip>
                        {/* <Tooltip title="Delete">
                            <IconButton
                                onClick={() => handleOpen(col.row, 'delete')}
                                color="error" size="small">
                                <DeleteForeverIcon fontSize="small" />
                            </IconButton>
                        </Tooltip>
                        <Tooltip
                            title={(col.row?.isActive) ? "Disable" : "Enable"}
                        >
                            <Switch
                                checked={col.row?.isActive || false}
                                onChange={() => { handleOpen(col.row, 'toggleStatus') }}
                                size='small'
                            />
                        </Tooltip> */}
                    </>
                )
            }
        },
    ]


    const handleViewDetails = (val) => {
        setIsLoading(true)
        postGeneric(`${apiConstants.VIEW_DETAILS_QC_CLICKPOST_MAPPING}?id=${val.id}`).then((res) => {
            if (res.status === 200) {
                setPreviewOpen(true)
                const cleanedHtml = decodeHtmlString(res.data);
                setIsEditData(cleanedHtml)
            } else {
                enqueueSnackbar('Error fetching data', { variant: 'error' })
            }
        }).catch((err) => {
            console.log(err)
            enqueueSnackbar('Error fetching data', { variant: 'error' })
        }).finally(() => {
            setIsLoading(false)
        })
    }

    const handleOpen = (val, type) => {
        setOpen(true)
        setVal(
            {
                rowData: val,
                type: type
            }
        )
    }

    const handleEdit = (val) => {
        setAddOpen(true)
        setIsEditData(val)
    }

    const handleDelete = () => {
        deleteGeneric(`${apiConstants.DELETE_QC_CLICKPOST_MAPPING}/${val?.rowData?.id}`).then((res) => {
            if (res.status === 200) {
                enqueueSnackbar('Deleted Successfully', { variant: 'success' })
            }
            setOpen(false)
            setReload(reload + 1)
        }).catch((err) => console.log(err))
    }

    const toggleStatus = () => {
        post(`${apiConstants.TOGGLE_QC_CLICKPOST_MAPPING_STATUS}?cpAccountCode=${val.rowData.cpAccountCode}&isActive=${!val.rowData.isActive}`).then((res) => {
            if (res.status === 200) {
                enqueueSnackbar('Status Updated Successfully', { variant: 'success' })
            }
            setOpen(false)
            setReload(reload + 1)
        }).catch((err) => console.log(err))
    }

    return (
        <>

            <PageTitle>QC Carrier Mapping</PageTitle>
            {(isLoading) && <Loader />}
            <Card>
                <CardHeader
                    action={
                        <Grid container spacing={2}>
                            <Grid item>
                                <Button
                                    variant="contained"
                                    size="small"
                                    startIcon={<AddIcon />}
                                    color="warning"
                                    onClick={() => { setAddOpen(true) }}
                                >
                                    Add Mapping
                                </Button>
                            </Grid>
                        </Grid>
                    }
                />
                <CardContent>
                    <FormProvider methods={methods} onSubmit={handleSubmit(onSubmit)}>
                        <Grid container spacing={1}>
                            <Grid item xs={12} md={4}>
                                <RHFSearchableSelectField
                                    fullWidth
                                    name="courier"
                                    label="Select CP Account Code"
                                    options={_.orderBy(courierList, 'name').map(val => ({
                                        value: val.cpAccountCode,
                                        label: val.cpAccountCode
                                    }))}
                                />
                            </Grid>
                            <Grid item xs={12} md={4}>
                                <RHFSelectField
                                    width="100%"
                                    name="isActive"
                                    label="Select Status"
                                    options={_.orderBy(statusOptions, 'name').map(val => ({
                                        value: val.value,
                                        label: val.label
                                    }))}
                                />
                            </Grid>
                            <Grid item xs={12} md={4} sx={{ mt: 1.5 }}>
                                <LoadingButton
                                    loading={isSubmitting}
                                    variant="contained"
                                    size="small"
                                    type="submit"
                                >Search</LoadingButton>
                                <Button variant="contained" color="error" size="small" sx={{ ml: 1 }}
                                    onClick={() => {
                                        reset()
                                        setReload(reload + 1)
                                    }}>Reset</Button>
                            </Grid>
                        </Grid>
                    </FormProvider>
                </CardContent>
            </Card>
            <Typography variant='body2' sx={{ mt: 2 }}>
                <ProzoDataGrid
                    columns={Columns}
                    autoHeight={true}
                    rows={data || []}
                    sizePerPage={sizePerPage}
                    setSizePerPage={setSizePerPage}
                    setPage={setPage}
                    page={page}
                    pagination={true}
                    paginationMode="client"
                    hideFooterPagination={false}
                    rowHeight={120}
                    rowCount={data?.length}
                    getRowId={(row) => row.id}
                    getRowHeight={() => 55}
                />
            </Typography>
            <Dialog
                open={open}
                onClose={() => setOpen(false)}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                fullWidth
            >
                <DialogTitle id="alert-dialog-title">
                    {""}
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        {val?.type === 'delete' ? "Are you sure you want to Delete ?" : `Are you sure you want to ${val?.rowData?.isActive ? "Disable" : "Enable"}  ?`}
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setOpen(false)} color="error" variant="contained">No</Button>
                    <Button onClick={val?.type === 'delete' ? handleDelete : toggleStatus} color="success" variant="contained">
                        Yes
                    </Button>
                </DialogActions>
            </Dialog>
            <SideDrawer title='Add carrier-logs'
                open={addOpen}
                setOpen={() => {
                    setAddOpen(false)
                    setIsEditData(null)
                }}
                drawerWidth='75%' children={
                    <AddEditQCClickpostMapping setAddOpen={setAddOpen} setReload={setReload} isEditData={isEditData} courierList={courierList} setIsEditData={setIsEditData} />
                }
            >
            </SideDrawer>
            <ViewHTMLPreview previewHtml={isEditData} previewOpen={previewOpen} setPreviewOpen={setPreviewOpen} setIsEditData={setIsEditData} />
        </>
    )
}
